export default __webpack_public_path__ + "static/media/Rakesh Ramakrishnan.fa3ee210.jpg";